import "../../stylesheets/App.css";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import UserAdminInformation from "./UserAdminInformation.js";
import PopupDeactivateUser from "./PopupDeactivateUser.js";
import ExportUsersButton from "./ExportUsersButton.js";
import Loader from "./Loader.js";

function AdminUserModule() {
  const [loadingUsers, setLoadingUsers] = useState(true);

  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  const [categoryActive, setCategoryActive] = useState(1);
  const [userActive, setUserActive] = useState(-1);
  const [deactivateUser, setDeactivateUser] = useState(-1);

  const [refresh, setRefresh] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [pages, setPages] = useState([1]);
  const [keywords, setKeywords] = useState("");

  const apiCall = async (url, onSuccess, onError) => {
    try {
      const res = await fetch(url);
      const data = await res.json();
      onSuccess(data);
    } catch (e) {
      console.log(e);
      onError && onError(e);
    }
  };

  const updateUsers = (data) => {
    setUsers(data.data || []);

    const total = data.total || 0;
    const cant = total % 20 === 0 ? Math.trunc(total / 20) : Math.trunc(total / 20) + 1;
    const vec = Array.from({ length: Math.max(cant, 1) }, (_, i) => i + 1);

    setPages(vec);
    setLoadingUsers(false);
  };

  const updateAllUsers = (data) => {
    setAllUsers(data.data || []);
  };

  const consult = (id) => setUserActive(id);
  const deactivate = (id) => setDeactivateUser(id);

  // ✅ 1) users paginados / búsqueda (se ejecuta cuando cambia algo relevante)
  useEffect(() => {
    setLoadingUsers(true);
    setUserActive(-1);

    const pageForApi = activePage - 1;

    const url =
      keywords !== ""
        ? `${process.env.REACT_APP_API_BASE_URL}/admin/userListPaginatedWithKeywords/${pageForApi}/${categoryActive}/${keywords}`
        : `${process.env.REACT_APP_API_BASE_URL}/admin/userListPaginated/${pageForApi}/${categoryActive}`;

    apiCall(
      url,
      updateUsers,
      () => setLoadingUsers(false) // ✅ evita loader infinito si falla
    );

    setRefresh(false);
  }, [categoryActive, refresh, activePage, keywords]);

  // ✅ 2) allUsers SOLO una vez (para exportar)
  useEffect(() => {
    apiCall(
      `${process.env.REACT_APP_API_BASE_URL}/users/orderList/1`,
      updateAllUsers
    );
  }, []);

  // ✅ reset page si cambia keywords o categoría
  useEffect(() => {
    setActivePage(1);
  }, [keywords, categoryActive]);

  return (
    <>
      {userActive === -1 ? (
        <section id="module-users-section-general" className="no-pd">
          <section className="admin-search-section">
            <div className="search-container-home">
              <button className="search-btn">
                <FontAwesomeIcon icon={solid("magnifying-glass")} />
              </button>
              <input
                type="text"
                placeholder="Buscar por nombre"
                onInput={(e) => setKeywords(e.currentTarget.value)}
              />
            </div>
          </section>

          <section>
            <ExportUsersButton users={allUsers} />
          </section>

          <section className="admin-users-list-section">
            <ul className="admin-user-list">
              {users.map((user) => (
                <li key={user.idUser}>
                  <p>{user.name}</p>
                  <div className="user-list-btn-contanier">
                    <button className="btn-consultar" onClick={() => consult(user.idUser)}>
                      Consultar
                    </button>
                    <button className="btn-desactivar" onClick={() => deactivate(user.idUser)}>
                      Eliminar usuario
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <section className="admin-list-paginator-section">
            {pages.length > 1 ? (
              <FontAwesomeIcon
                icon={solid("chevron-left")}
                className="opacity-50 cursor-pointer hover:opacity-100"
                onClick={() => (activePage > 1 ? setActivePage(activePage - 1) : null)}
                size={"sm"}
              />
            ) : null}

            {pages.length > 1
              ? pages.map((page) =>
                  page === 1 ||
                  (page > activePage - 2 && page < activePage + 2) ||
                  page === pages.length ? (
                    <button
                      className={activePage === page ? "pag-item active" : "pag-item"}
                      key={"item-" + page}
                      onClick={(e) => setActivePage(parseInt(e.currentTarget.value))}
                      value={page}
                    >
                      {page}
                    </button>
                  ) : page === activePage - 2 || page === activePage + 2 ? (
                    <span key={"dots-" + page}>...</span>
                  ) : null
                )
              : null}

            {pages.length > 1 ? (
              <FontAwesomeIcon
                icon={solid("chevron-right")}
                className="opacity-50 cursor-pointer hover:opacity-100"
                onClick={() => (activePage < pages.length ? setActivePage(activePage + 1) : null)}
                size={"sm"}
              />
            ) : null}
          </section>
        </section>
      ) : (
        <section id="module-users-section-detail">
          <button
            className="header-btn"
            onClick={() => {
              setUserActive(-1);
              setKeywords("");
            }}
          >
            <FontAwesomeIcon icon={solid("chevron-left")} />
          </button>

          {users.length > 0 && (
            <UserAdminInformation user={users.find((u) => u.idUser === userActive)} />
          )}

          <button className="btn red-btn" onClick={() => deactivate(userActive)}>
            Eliminar usuario
          </button>
        </section>
      )}

      {deactivateUser !== -1 ? (
        <PopupDeactivateUser
          id={deactivateUser}
          setDeactivateUser={setDeactivateUser}
          setRefresh={setRefresh}
        />
      ) : null}

      {loadingUsers ? <Loader /> : null}
    </>
  );
}

export default AdminUserModule;
